import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageModule } from 'primeng/image';


export interface DisplayImagesGroup {
  label?: string;
  value?: string[];
}

@Component({
  selector: 'app-display-images',
  standalone: true,
  imports: [CommonModule, ImageModule],
  templateUrl: './display-images.component.html',
  styleUrls: ['./display-images.component.scss'],
})
export class DisplayImagesComponent {
  @Input() images: DisplayImagesGroup[] = [];
}
